import {create} from 'zustand';
import {persist, createJSONStorage} from 'zustand/middleware';

/**
 * Persisted store of an admin's favorite dashboard tabs/pages.
 *
 * Favorites are keyed by user id so each admin (currently super admins) keeps
 * their own list across logins. Only the stable entry ids from the dashboard
 * search index are stored — labels/icons/routes are re-hydrated from the live
 * index at render time, so favorites stay correct even if a tab is renamed.
 */
export const useFavoritesStore = create(
  persist(
    (set, get) => ({
      // { [userId]: string[] } — ordered list of favorite entry ids
      favoritesByUser: {},

      toggleFavorite: (userId, entryId) => {
        if (!userId || !entryId) return;
        set(state => {
          const current = state.favoritesByUser[userId] || [];
          const next = current.includes(entryId)
            ? current.filter(id => id !== entryId)
            : [...current, entryId];
          return {
            favoritesByUser: {...state.favoritesByUser, [userId]: next},
          };
        });
      },

      isFavorite: (userId, entryId) =>
        (get().favoritesByUser[userId] || []).includes(entryId),

      getFavorites: userId => get().favoritesByUser[userId] || [],
    }),
    {
      name: 'dashboardFavorites',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
